import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './ResultPage.css';

const ResultPage = () => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 1000); // 2 minutes in milliseconds

  useEffect(() => {

    // Countdown timer
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [navigate]);



  return (
    <div className="result-page">

    </div>
  );
};

export default ResultPage;
